module.exports = __webpack_public_path__ + "static/media/ML.b1fcb9a6.svg";